import React from 'react';
import { FileText, Search, FileBadge } from 'lucide-react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const steps = [
  { icon: FileText, title: 'Consultation', desc: 'Share your brand details for a free evaluation. Our team assesses registrability and identifies conflicts within 24 hours.' },
  { icon: Search, title: 'Clearance Search', desc: 'Licensed attorneys search USPTO, state, common law, and domain records to confirm your mark is clear for registration.' },
  { icon: FileBadge, title: 'Filing & Registration', desc: 'We prepare your complete application, file with USPTO, and monitor through examination to certificate issuance.' }
];

const LPHowItWorksSection = ({ onOpenModal }) => (
  <section className="py-24 bg-white" data-testid="lp-how-it-works-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <p className="eyebrow mb-4">The Process</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter">Three steps to protection</h2>
        <p className="font-body text-base text-[#4A5D53] mt-4 max-w-2xl mx-auto">
          From consultation to USPTO registration — we handle everything while you focus on growing your business
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((s, i) => (
          <div key={i} className="relative text-center group cursor-pointer p-8 rounded-3xl transition-all duration-300 hover:bg-[#F9F8F6] hover:shadow-lg hover:-translate-y-2" data-testid={`hiw-step-${i}`}>
            <div className="flex justify-center mb-6">
              <div className="w-14 h-14 rounded-2xl bg-[#C85A40] flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                <s.icon className="h-7 w-7 text-white" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="font-display text-xl font-bold text-[#111C16] mb-3 transition-colors duration-300 group-hover:text-[#C85A40]">{s.title}</h3>
            <p className="font-body text-sm text-[#4A5D53] leading-relaxed max-w-xs mx-auto">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <Button onClick={() => onOpenModal('How It Works - Get Started')} className="bg-[#1A3628] hover:bg-[#11241A] text-white btn-hover py-6 px-10" data-testid="lp-hiw-cta-btn">
          Begin Your Filing
        </Button>
      </div>
    </div>
  </section>
);

export default LPHowItWorksSection;
